import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Privacy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Política de Privacidad
        </Typography>
        <Typography variant="body1" paragraph>
          En Jooru, respetamos tu privacidad y nos comprometemos a proteger 
          tu información personal.
        </Typography>
        <Typography variant="body1">
          Esta política describe cómo recopilamos, usamos y protegemos tu información.
        </Typography>
      </Box>
    </Container>
  );
};

export default Privacy;